import { useEffect, useState } from "react";
import { useChangeAuthenticatedUserPassword } from "react-redux-django-auth";
import Button from "../../../components/common/Button";
import Input from "../../../components/common/Input";
import { Lock, CheckCircle2, AlertCircle } from "lucide-react";
import { useToast } from "../../../hooks/otherHooks/useToast";

const ChangePassword = () => {
    const { addToast } = useToast();

    // Initial Data
    const initialFormData = {
        current_password: "",
        new_password: "",
        re_new_password: "",
    };

    const { error, formData, loading, onChange, onSubmit, status } =
        useChangeAuthenticatedUserPassword(initialFormData);

    const [successMsg, setSuccessMsg] = useState("");

    useEffect(() => {
        if (status === 204 || status === 200) {
            const msg = "Password changed successfully! Please use your new password next time you sign in.";
            setSuccessMsg(msg);
            if (addToast) {
                addToast({
                    message: msg,
                    bg: "success",
                });
            }
        }
    }, [status, addToast]);

    useEffect(() => {
        if (error && !successMsg) {
            const errText = typeof error === "string" ? error : "An error occurred while changing password.";
            if (addToast) {
                addToast({
                    message: errText,
                    bg: "danger",
                });
            }
        }
    }, [error, successMsg, addToast]);

    return (
        <section className="cht-max-w-2xl cht-mx-auto cht-py-4">
            <form onSubmit={(e) => { setSuccessMsg(""); onSubmit(e); }} className="cht-bg-white cht-rounded-3xl cht-p-8 md:cht-p-10 cht-border cht-border-gray-100 cht-shadow-soft">
                <header className="cht-text-center cht-mb-8">
                    <h3 className="cht-text-2xl cht-font-black cht-text-[#1e293b] mb-2">Change your Password</h3>
                    <p className="cht-text-sm cht-text-gray-500 font-medium">
                        Confirm your current password and enter a new secure one below.
                    </p>
                </header>

                {successMsg && (
                    <div className="cht-mb-6 cht-p-4 cht-rounded-2xl cht-bg-emerald-50 cht-border cht-border-emerald-200 cht-text-emerald-700 cht-text-xs cht-font-bold cht-flex cht-items-center cht-gap-2.5">
                        <CheckCircle2 size={16} />
                        <span>{successMsg}</span>
                    </div>
                )}

                {error && !successMsg && (
                    <div className="cht-mb-6 cht-p-4 cht-rounded-2xl cht-bg-rose-50 cht-border cht-border-rose-200 cht-text-rose-700 cht-text-xs cht-font-bold cht-flex cht-items-center cht-gap-2.5">
                        <AlertCircle size={16} />
                        <span>{typeof error === "string" ? error : "An error occurred while changing password."}</span>
                    </div>
                )}

                <div className="cht-space-y-5">
                    <Input
                        label="Current Password"
                        type="password"
                        id="current_password"
                        name="current_password"
                        placeholder="••••••••"
                        leftIcon={<Lock size={18} />}
                        onChange={(e: any) => onChange(e)}
                        value={formData.current_password}
                        required
                    />

                    <Input
                        label="New Password"
                        type="password"
                        id="new_password"
                        name="new_password"
                        placeholder="••••••••"
                        leftIcon={<Lock size={18} />}
                        onChange={(e: any) => onChange(e)}
                        value={formData.new_password}
                        required
                    />

                    <Input
                        label="Confirm New Password"
                        type="password"
                        id="re_new_password"
                        name="re_new_password"
                        placeholder="••••••••"
                        leftIcon={<Lock size={18} />}
                        onChange={(e: any) => onChange(e)}
                        value={formData.re_new_password}
                        required
                    />

                    <div className="cht-pt-4">
                        <Button
                            type="submit"
                            variant="primary"
                            isLoading={loading}
                            className="cht-w-full cht-py-4 cht-rounded-2xl"
                        >
                            Change Password
                        </Button>
                    </div>
                </div>
            </form>
        </section>
    );
};

export default ChangePassword;
